<!-- <ngx-spinner>Loading...</ngx-spinner> -->
<ngx-spinner>Loading...</ngx-spinner>
<header class="" app-portal-header></header>
<div class="page-content fade-in-up" style="overflow-x: hidden;">
  <div class="row" style="padding: 5px 20px  20px 20px">
    <div class="col-12">
<div class="ibox" >
 

    <br>


    
    <div class="ibox-body ">
      <div class="ibox-head" *ngIf="pathToDashBoard">
        <ul class="nav nav-tabs tabs-line" style="width: 100%; border:none">
          <li class="nav-item" style="display: flex;
                width: 100%;
                justify-content: space-around;">
            <div class="ibox-title" *ngIf="erpUser" style="font-family: Poppins;"><h5><b> Welcome,{{erpUser.party_name}} Upneda</b></h5> </div>
            <!-- <div class="ibox-title"> <a href="/file-overView" routerLink="/file-overView"> Go To The Dashboard </a> -->
              <!-- <div class="wrapper1">
                <a class="cta" href="/profile" routerLink="/profile">
                  <span>  Welcome,{{erpUser.party_name}} </span>
                  <span style="margin-top: -3px;">
                    <svg width="66px" height="20px" viewBox="0 0 66 43" version="1.1" xmlns="" xmlns:xlink="">
                      <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path class="one" d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                        <path class="two" d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                        <path class="three" d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z" fill="#FFFFFF"></path>
                      </g>
                    </svg>
                  </span> 
                </a>
              </div> -->
           
              
            <!-- </div> -->
          </li>
        </ul>
      </div>
      <div class="row" *ngIf="!pathToDashBoard">
        <div class="col-12 text-center">
          <h3 *ngIf="erpUser"><b>Welcome ,{{erpUser['party_name']}}</b> </h3>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <!-- <div  style="display: inline;"> -->
        <div *ngFor="let p of pr index as i" class="col-3 text-center" >
          <button type="button" class="btn new_hover" (click)="route(p['module_cd'])" >
            <img src="./assets/img/dash/{{imgUrl[p['module_cd']]}}">
          </button>
          <h6 >{{p['module_name']}}</h6>
        </div>
        <div class="wrapper1  text-right  col-12" *ngIf="pathToDashBoard" >
          <a class="cta" href="/file-overView" routerLink="/file-overView">
            <span>   Go To The Dashboard   </span>
            <span style="margin-top: -3px;">
              <svg width="66px" height="15px" viewBox="0 0 66 43" version="1.1" xmlns="" xmlns:xlink="">
                <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path class="one" d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                  <path class="two" d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                  <path class="three" d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z" fill="#FFFFFF"></path>
                </g>
              </svg>
            </span> 
          </a>
        </div>
        <!-- <div class="col-6 text-center">
                  <button type="button" class="btn" (click)="route(col3[0])">
                      <img src="./assets/img/dash/{{imgUrl[col3[0]]}}">
                  </button>
                  <h6>{{col3[0]}}</h6>
              </div> -->
      </div>
      <!-- <div class="row" *ngIf="account_flag && !(account_flag && hr_flag)">
              <div class="col-12 text-center">
                  <button type="button" class="btn" (click)="route(col1[0])">
                      <img src="./assets/img/dash/{{imgUrl[col1[0]]}}">
                  </button>
                  <h6>{{col1[0]}}</h6>
              </div>

          </div>
          <div class="row" *ngIf="hr_flag &&  !(account_flag && hr_flag)">
              <div class="col-12 text-center">
                  <button type="button" class="btn" (click)="route(col3[0])">
                      <img src="./assets/img/dash/{{imgUrl[col3[0]]}}">
                  </button>
                  <h6>{{col3[0]}}</h6>
              </div>

          </div> -->
          <br>
          <div class="row">
            <!-- <div class="col-1"></div> -->
            <div class="col-12">
              <marquee style="color: red;margin: auto;display: block;width: 90%;font-weight: bold;">
                <h6><b>For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241</b></h6>
              </marquee>
            </div>
            <!-- <div class="col-1"></div> -->
      
          </div>
      <br>
      <!-- <hr> -->
      <!-- <div class="row">
              <div class="col-3 text-center">
                  <button type="button" class="btn" (click)="portal('leave')">
                      <img src="./assets/img/dash/leave.png">
                  </button>
                  <h6>LEAVE</h6>
              </div>
              <div class="col-3 text-center">
                  <button type="button" class="btn" (click)="portal('salary')">
                      <img src="./assets/img/dash/salary.png">
                  </button>
                  <h6>YOUR SALARY</h6>

              </div>
              <div class="col-2 text-center">
                  <button type="button" class="btn" (click)="portal('profile')">
                      <img src="./assets/img/dash/personalinfo.jpg">
                  </button>
                  <h6>YOUR INFO</h6>
              </div>
              <div class="col-2 text-center">
                  <button type="button" class="btn" (click)="portal('task')">
                      <img src="./assets/img/dash/task.jpeg">
                  </button>
                  <h6>YOUR TASKS</h6>
              </div>
              <div class="col-2 text-center" *ngIf="is_admin==1">
                  <button type="button" class="btn" (click)="portal('appr')">
                      <img src="./assets/img/dash/doc.jpg">
                  </button>
                  <h6>DOCUMENT TRACKING</h6>
              </div>
          </div> -->
      <!-- <hr class="custom-line" *ngIf="pathToDashBoard"> -->

      <!-- <div class="row">
        <div class="col-12 text-center">
          <div class="font-13">2023 © <b>PCS Management Consultancy Pvt. Ltd.</b> - All rights reserved..
          </div>
        </div>
        <div class="col-12 text-center">
          <div class="font-13">build=erpbuild</div>
        </div> -->
    
  </div>


</div>
</div>
</div>
</div>
  <!-- <div hidden>
    <app-portal-sidebar></app-portal-sidebar>
</div> -->
